require('./index-style-only');

module.exports = require('./src');
